export * from './useExtensionsPhotoCapture';
